/*
const CH2Events = {
    OPEN3DVIEWER: 'open_viewer',
    CLOSE3DVIEWER: 'close_viewer',
    OPENCONFIGURATOR: 'open_configurator',
    DOWNLOADAR: 'download_augmented_reality',
    SCREENSHOT: 'screenshot',
    FULLSCREEN: 'fullscreen',
    INSTRUCTIONS: 'instructions',
    CONFIGURATION: 'configuration',
};
const CH2Color = {
    WHITE: '#FFFFFF',
    WHITEG: '#CFD2D1',
    YELLOWG: '#BF8700',
    ROSEG: '#D5A87F',
    RED: '#BF2D38',
    CLEARBLACK: '#000000',
    GREEN: '#01964C',
    BLUE: '#1B3E8F',
};
const CH2ProductType = {
    JEWEL: 'JEWEL',
    TONEOVERTONE: 'TONEOVERTONE',
    COLOR: 'COLOR',
};
const CH2ConfigMode = {
    LETTERS: 'LETTERS',
    DATES: 'DATES',
    SYMBOLS: 'SYMBOLS',
    CHSYMBOLS: 'CHSYMBOLS',
};

this.analytics.logEvent('configuration', 'color_selected', color);

this.analytics.logEvent('configurator', 'position_selected', position);

this.analytics.logEvent('configuration', 'mode_selected', _mode);
*/

const productBase = require('../product/base');

const BvlgariEventMap = {
    configurator_open: 'configurator_open',
    configurator_close: 'close',
    configurator_add_to_bag: 'configurator_add_to_bag',
    configuration_mode: 'configuration_mode',
    configuration_text: 'configuration_text',
    configuration_color: 'configuration_color', // not used atm
    configuration_position: 'configuration_position', // not used atm
    configuration_reset: 'reset',
};

class CH2Analytics {
    constructor() {
        this.module = 'CH2';
        this.featureName = '';
        this.featureChoice = '';
    }

    logEvent(_type, _paramName, _paramValue) {
        const eventName = `${this.module}_${_type}`;
        let eventParameter = '';
        if (_paramName && _paramValue) {
            eventParameter = { _paramName: _paramValue };
        }
        /*
        gtag('event', eventName, {
            param
        });
        */
    }

    logText(_mode, _text, _position) {
        const eventName = `${this.module}_configuration`;
        const eventParameters = {
            mode: _mode,
            text: _text,
            position: _position,
        };
        /*
        gtag('event', eventName, {
            param
        });
        */
    }

    logBulgariError(_errorType) {
        const productId = productBase.getPidValue() || '';

        const productNameElement = $('.product-name');
        const productName = productNameElement.length > 0 ? productNameElement.first().text().trim() : 'Bvlgari Product';

        const dataLayer = window.dataLayer ?? [];
        dataLayer.push({
            event: '3dview_error',
            error_type: _errorType,
            product_name: productName,
            product_id: productId,
        });
    }

    logBvlgariEvent(_eventName, _eventParameter) {
        const ctaName = BvlgariEventMap[_eventName] ?? '';
        if (ctaName === '') {
            console.log('Bulgari GA4: Event not mapped');
            return;
        }

        this.featureName = '';
        this.featureChoice = '';

        const dataLayer = window.dataLayer ?? [];
        // eslint-disable-next-line default-case
        switch (ctaName) {
        case BvlgariEventMap.configuration_position:
            this.featureName = this.parameterToPosition(_eventParameter);
            this.featureChoice = '';
            break;
        case BvlgariEventMap.configurator_add_to_bag:
            dataLayer.push({
                event: 'personalization_validate',
                product_name: _eventParameter?.productName,
                personalization_type: !_eventParameter?.isEngraving ? _eventParameter?.currentMode : undefined,
                engraving_type: _eventParameter?.isEngraving ? _eventParameter?.currentMode : undefined,
            });
            break;
        default:
            if (ctaName === BvlgariEventMap.configuration_reset || ctaName === BvlgariEventMap.configurator_close) {
                dataLayer.push({
                    event: 'product_customisation',
                    cta_name: ctaName,
                });
            }
            break;
        }
    }

    parameterToPosition(_positionParameter) {
        return _positionParameter === '0' ? 'Mirror' : 'Shoulder Strap';
    }

    parameterToColor(_colorParameter) {
        switch (_colorParameter) {
        case '#CFD2D1':
            return 'White Gold';
        case '#BF8700':
            return 'Yellow Gold';
        case '#D5A87F':
            return 'Rose Gold';
        case '#BF2D38':
            return 'Ruby Red';
        case '#01964C':
            return 'Emerald Green';
        case '#1B3E8F':
            return 'Royal Sapphire';
        case '#000000':
            return 'Tone Over Tone';
        default:
            console.log('Bulgari GA4: Color not mapped');
            return '';
        }
    }

    parameterToMode(_modeParameter) {
        switch (_modeParameter) {
        case 'LETTERS':
            return 'Letters & symbols';
        case 'DATES':
            return 'Date';
        case 'SYMBOLS':
            return 'Western Zodiac';
        case 'CHSYMBOLS':
            return 'Chinese zodiac';
        default:
            console.log('Bulgari GA4: Mode not mapped');
            return '';
        }
    }
}

module.exports = CH2Analytics;
